import type { IconProps } from '../types/IconProps.ts';
export const FileDiff: IconProps = {
    name: 'FileDiff',
    children: [
        `<path d="M4 4c0-1.1.9-2 2-2h8.17a2 2 0 0 1 1.42.59L19.4 6.4a2 2 0 0 1 .6 1.43V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zM12 7v6M9 10h6M9 17h6" />`,
    ]
};